(() => {
  // app/scripts/faq-page.js
  window.addEventListener("DOMContentLoaded", () => {
    const tags = document.querySelectorAll(".tag-faq");
    tags.forEach((tag) => {
      tag.addEventListener("click", (e) => {
        console.log(e.target.dataset.nav);
        const id = e.target.dataset.nav;
        const yOffset = -240;
        const element = document.getElementById(id);
        console.log(id);
        const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
        window.scrollTo({ top: y, behavior: "smooth" });
      });
    });
  });
})();
